import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthService } from './http-services/authservice.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UnitsService {

  constructor(private httpClient: HttpClient, private auth: AuthService) { }

  ExamId: Subject<number> = new Subject();
  configureHeaders() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    headers = headers.set('Authorization', `Bearer ${this.auth.token}`);
    return headers;
  }

  async getUnitsConfig() {
    return this.httpClient.get(
      `${environment.apiURL}units/configs`, { headers: this.configureHeaders() }).toPromise();
  }

  async buyUnits(units) {
    return this.httpClient.post(
      `${environment.apiURL}units/buy`, units, { headers: this.configureHeaders() }).toPromise();
  }

  async verifyPayment(paymentId) {
    return this.httpClient.get(
      `${environment.apiURL}units/verify/${paymentId}`, { headers: this.configureHeaders() }).toPromise();
  }

  async getUnitsAvailable() {
    return this.httpClient.get(
      `${environment.apiURL}units/available`, { headers: this.configureHeaders() }).toPromise();
  }
}
